"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Braze = void 0;
const Actions_1 = require("./Actions");
exports.Braze = {
    createActions: (config) => {
        if (typeof window !== undefined) {
            window.FoxBraze = new Actions_1.BrazeActions(config);
        }
    },
    contentCardClickAction: (banner) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { upgradeSubscription = "", downgradeSubscription = "", applyCoupon: baseApplyCoupon = "", } = (_a = banner === null || banner === void 0 ? void 0 : banner.extras) !== null && _a !== void 0 ? _a : {};
        const applyCoupon = baseApplyCoupon.toUpperCase();
        const newPlanId = upgradeSubscription || downgradeSubscription;
        if (applyCoupon && !newPlanId) {
            yield window.FoxBraze.applyCoupon(applyCoupon);
        }
        else if (newPlanId) {
            yield window.FoxBraze.updateSubscription({
                planId: newPlanId,
                isDowngrade: !!downgradeSubscription,
                promotionId: "",
                couponCode: applyCoupon,
            });
        }
    }),
};
//# sourceMappingURL=index.js.map